import type { WizardStatus } from '@risksmart-app/domain/src/types/consts/wizard-status';
import type {
  InsertWizardMutation,
  InsertWizardMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertWizardDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertWizardTRPCInput = {
  RiskId: string;
  AssessmentId?: string | null;
  ActivityId?: string | null;
  Status?: WizardStatus | null;
};

export const useInsertWizard = createMutationHook({
  name: 'insertWizard',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.wizard.insert.mutationOptions({ onSuccess }),
  mapInput: (
    variables: InsertWizardMutationVariables
  ): InsertWizardTRPCInput => {
    const obj = variables.object;

    return {
      RiskId: obj?.RiskId ?? '',
      AssessmentId: obj?.AssessmentId,
      ActivityId: obj?.ActivityId,
      Status: obj?.Status,
    };
  },
  invalidate: (trpc) => [
    trpc.frontend.wizard.wizards.queryKey(),
    trpc.frontend.wizard.wizardById.queryKey(),
  ],
  mapResponse: (trpcData: { RiskId: string }): InsertWizardMutation => ({
    insertChildWizard: {
      __typename: 'InsertWizardOutput',
      RiskId: trpcData.RiskId,
    },
  }),
  graphqlDocument: InsertWizardDocument,
  graphqlVariables: (variables: InsertWizardMutationVariables) => variables,
  evictFields: ['wizard'],
});
